import { render } from "./Layout.vue?vue&type=template&id=78a93588"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/karsten/Dropbox (Privat)/htdocs/wintitower/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__